var _path, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVoucherIconValue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 48,
    viewBox: "0 0 85 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.4123 11.52C41.4123 10.752 42.0523 10.144 42.8203 10.144C43.5883 10.144 44.1963 10.752 44.1963 11.52V12.224C46.0843 12.448 47.6843 13.056 49.1563 13.984C49.6683 14.272 50.1163 14.752 50.1163 15.52C50.1163 16.512 49.3163 17.28 48.3243 17.28C48.0043 17.28 47.6843 17.184 47.3643 16.992C46.2443 16.32 45.1563 15.84 44.0683 15.584V21.728C48.9323 22.944 51.0123 24.896 51.0123 28.32C51.0123 31.84 48.2603 34.176 44.1963 34.56V36.48C44.1963 37.248 43.5883 37.856 42.8203 37.856C42.0523 37.856 41.4123 37.248 41.4123 36.48V34.496C39.0123 34.24 36.8043 33.376 34.8523 32C34.3083 31.648 33.9883 31.136 33.9883 30.464C33.9883 29.472 34.7563 28.704 35.7483 28.704C36.1323 28.704 36.5163 28.832 36.8043 29.056C38.3083 30.144 39.7803 30.88 41.5403 31.2V24.896C36.8683 23.68 34.6923 21.92 34.6923 18.304C34.6923 14.88 37.4123 12.512 41.4123 12.192V11.52ZM47.2363 28.544C47.2363 27.136 46.5323 26.272 44.0683 25.504V31.328C46.1163 31.104 47.2363 30.08 47.2363 28.544ZM38.4683 18.08C38.4683 19.424 39.0763 20.256 41.5403 21.056V15.392C39.4923 15.584 38.4683 16.672 38.4683 18.08Z",
    fill: "#F6931E"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 24,
    r: 22.5,
    stroke: "#F6931E",
    strokeWidth: 3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoucherIconValue);
export default __webpack_public_path__ + "static/media/voucher-icon_value.bc65a3123dbdf267e14a4e99649c0e6b.svg";
export { ForwardRef as ReactComponent };